import { IModuleWithSettings } from '../types/IModuleWithSettings';
import { LabeledTimelineActivity } from '../types/LabeledTimelineActivity';
import { Status } from '../../../core/api/Enums/Status';
import InfoMessageService from '../../../core/services/InfoMessageService';
import TimelineApiClient from '../api/CaseTimelineApiClient';

type LabelIcon = {
  [name: string]: string;
};

type LabelFilter = {
  filter: (code: string) => boolean;
  label: string;
};

class CaseTimelineService {
  async getTimeline(caseId: string, module: IModuleWithSettings): Promise<LabeledTimelineActivity[]> {
    const model = await TimelineApiClient.getCaseTimeline(module.id, caseId);
    const modelData = model.data;
    const labelIcons: LabelIcon = {};

    if (model.status !== Status.Success) {
      InfoMessageService.displayActionStatusTyped(model);
      return [];
    }

    labelIcons['f1'] =
      'data:image/svg+xml;base64,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';

    const labelFilters: LabelFilter[] = [];

    for (const labelName in modelData.caseTimelineDictionary) {
      if (modelData.caseTimelineDictionary.hasOwnProperty(labelName)) {
        const label = modelData.caseTimelineDictionary[labelName];

        const codes = label.value.split(',');

        codes.forEach((code) => {
          if (code.includes('-')) {
            const codeRange = code.split('-');
            const from = Number(codeRange[0]);
            const to = Number(codeRange[1]);
            labelFilters.push({
              filter: (code) => {
                const numCode = Number(code);
                return from <= numCode && numCode <= to;
              },
              label: labelName,
            });
          } else {
            const exactCode = code;
            labelFilters.push({
              filter: (code) => code === exactCode,
              label: labelName,
            });
          }
        });
      }
    }

    const labeledTimeline: LabeledTimelineActivity[] = [];

    for (const labelKey in modelData.labeledActivities) {
      if (modelData.labeledActivities.hasOwnProperty(labelKey)) {
        const labeledActivitie = modelData.labeledActivities[labelKey];
        labeledActivitie.activities.forEach((a) => {
          labeledTimeline.push({
            code: a.statusCode,
            date: a.date,
            icon: modelData.caseTimelineDictionary[labelKey].imageData,
            color: modelData.caseTimelineDictionary[labelKey].color,
            label: labeledActivitie.label,
            title: a.activityDescription,
          });
        });
      }
    }

    return labeledTimeline;
  }
}

export default new CaseTimelineService();
